import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import DaoMembersSection from './components/DaoMembersSection';
import { colors } from './css/revenueItems.styles';

const bodySx = {
  color: colors.textSecondary,
  fontFamily: 'Questrial, sans-serif',
  lineHeight: 1.5,
};

const MembersTab = ({ currentDao, daoOrganizerAddress, onRefreshDao }) => {
  const [walletAddress, setWalletAddress] = useState('');
  const [isOrganizer, setIsOrganizer] = useState(false);
  const [hasProvider, setHasProvider] = useState(!!window.ethereum);

  useEffect(() => {
    const checkOrganizerPermission = async () => {
      const hasEth = !!window.ethereum;
      setHasProvider(hasEth);

      if (!hasEth || !daoOrganizerAddress) {
        setWalletAddress('');
        setIsOrganizer(false);
        return;
      }

      try {
        const accounts = await window.ethereum.request({ method: 'eth_accounts' });
        const currentAddress = (accounts?.[0] || window.ethereum.selectedAddress || '').toLowerCase();
        const organizerAddress = String(daoOrganizerAddress).trim().toLowerCase();
        setWalletAddress(currentAddress || '');
        setIsOrganizer(!!currentAddress && currentAddress === organizerAddress);
      } catch (error) {
        setWalletAddress('');
        setIsOrganizer(false);
      }
    };

    checkOrganizerPermission();

    if (!window.ethereum) return undefined;

    const handleAccountsChanged = () => {
      checkOrganizerPermission();
    };

    window.ethereum.on('accountsChanged', handleAccountsChanged);
    return () => {
      window.ethereum.removeListener('accountsChanged', handleAccountsChanged);
    };
  }, [daoOrganizerAddress]);

  if (isOrganizer) {
    return (
      <DaoMembersSection
        currentDao={currentDao}
        isOrganizer={isOrganizer}
        walletAddress={walletAddress}
        onDaoRefresh={onRefreshDao}
      />
    );
  }

  let accessMessage = 'Connect the DAO organizer wallet in MetaMask to manage members.';
  if (!daoOrganizerAddress) {
    accessMessage = 'This DAO does not have an organizer wallet configured yet.';
  } else if (!hasProvider) {
    accessMessage = 'Install and open MetaMask, then connect the DAO organizer wallet to manage members.';
  } else if (!walletAddress) {
    accessMessage = 'Connect your MetaMask wallet. Member management is available only with the DAO organizer wallet.';
  } else {
    accessMessage =
      'You do not have permission to access this content. Only the DAO organizer can access this section.';
  }

  return (
    <Box sx={{ width: '100%' }}>
      <Typography
        variant="h6"
        sx={{ mb: 3, pb: 2, color: '#fff', borderBottom: '1px solid rgba(255, 255, 255, 0.1)' }}
      >
        DAO Members
      </Typography>
      <Typography sx={bodySx}>{accessMessage}</Typography>
    </Box>
  );
};

export default MembersTab;
